// JS CONFIG
var loadEvents = false;
var modallogin = 1;
var sortbytype = 1;
var devmode = 0;
var stage = 0;
var maintenance = 0;
var registration_notice = 0;

if (stage) {
    $('body').append('<div class="stagenotice">Passport Staging Server</div>');
}

// ASSETS
var passportimage = `<img src="${upp_assets.images.logo}" alt="Ultra Passport&trade;" width="200" class="mb25">`;

// PASSPORT
var uppgold = 100000;
var uppplatinum = 200000;
var level = 'silver';
var neededpoints = 0;
var nextpercent = 0;
var gold = false;
var platinum = false;
var levelnextname = 'gold';
var levelpointsstart = 0;
var levelpointsend = uppgold;

function homeEvents() {
    getEventJSON()
    .done(function(data) {

        var events = _.sortBy(data, 'title');

        var event_options = `<option value="" disabled="" selected="">— ${_pleaseselect} —</option>`;

        $.each( eventTypes, function( k, v ) {
            $.each( _.filter(events, { 'type': v.type, 'visibility': { 'home_event': true } }), function( key, val ) {
                event_options += `<option value="${val.passport.subscription_code}">${val.title_label_short}</option>`;
            });
        });

        $('[name="homeevent"]').html(event_options);
        $('[name="newhomeevent"]').html(event_options);
        $('[name="event"]').html(event_options);

        var current_event = $('#event').data('event');
        $(`select#event option[value="${current_event}"]`).attr('selected', true);
    });
}

function getHomeEvents(label) {
    return getEventsByType()
        .done(function (events) {
            var event_options = `<option value="" disabled="" selected="">— ${label} —</option>`;

            event_options += _(events)
                .map(eventType => _(eventType.events)
                    .filter(event => event.visibility.home_event)
                    .map(eventType, event => `<option value="${event.passport.subscription_code}">${event.title_label_short}</option>`)
                    .join(''))
                .join('');
            return event_options;
        });
}

moment.locale(ultra_settings.locale);

// DETECT HOST
var hosturl = document.location.hostname;

// DEFAULTS

var _createaccountheader = '';

// RESISTANCE IBIZA THEME
if(ultra_settings.theme === 'ibiza') {

    if ( pplang == 'en') {
        $('[data-field="icon"]').html(`<img src="${upp_assets.images.levels.silver.icon}">`);
        _createaccountheader = `<span class="upp-photo tiny-hide2"><img src="${upp_assets.images.levels.silver.icon}"></span> Sign Up`;
    }
}
